import { useCallback, useMemo, useState } from 'react';
import { NumberParam, StringParam, useQueryParam, withDefault } from 'use-query-params';
// use either useState or useQueryParam hook
function useStateQuery(name, paramConfig, defaultValue, asState = true) {
    const query = useQueryParam(name, withDefault(paramConfig, defaultValue));
    const state = useState(defaultValue);
    return asState ? state : query;
}
export function useSiteTablePagination(props) {
    var _a, _b, _c, _d;
    const asState = !(props === null || props === void 0 ? void 0 : props.asQueryParams);
    const [page, setPage] = useStateQuery('page', NumberParam, (_a = props === null || props === void 0 ? void 0 : props.page) !== null && _a !== void 0 ? _a : 0, asState);
    const [limit, setLimit] = useStateQuery('limit', NumberParam, (_b = props === null || props === void 0 ? void 0 : props.limit) !== null && _b !== void 0 ? _b : 100, asState);
    const [order, setOrder] = useStateQuery('order', StringParam, (_c = props === null || props === void 0 ? void 0 : props.order) !== null && _c !== void 0 ? _c : '', asState);
    const [direction, setDirection] = useStateQuery('direction', StringParam, (_d = props === null || props === void 0 ? void 0 : props.direction) !== null && _d !== void 0 ? _d : 'DESC', asState);
    const pagination = useMemo(() => {
        return { page, limit, order, direction };
    }, [page, limit, order, direction]);
    const setPagination = useCallback((params) => {
        const { page, limit, order, direction } = params;
        typeof page !== 'undefined' && setPage(page);
        typeof limit !== 'undefined' && setLimit(limit);
        typeof order !== 'undefined' && setOrder(order);
        typeof direction !== 'undefined' && setDirection(direction);
    }, [setPage, setLimit, setOrder, setDirection]);
    const isActive = (column) => order === column;
    const handleSort = (column) => {
        setOrder(column);
        setDirection(direction === 'ASC' ? 'DESC' : 'ASC');
    };
    const getSortDirection = (column) => {
        return order === column && direction === 'DESC' ? 'desc' : 'asc';
    };
    return { pagination, setPagination, isActive, handleSort, getSortDirection };
}
//# sourceMappingURL=useSiteTablePagination.js.map